import React, {useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import {SHARING_COPY, SharingEventLogger} from '../../../services/analytics/sharing';
import useOnClickOutside from '../../hooks/use-click-outside';
import {useArticleModel} from '../../utils/shared/useArticleModel';
import {ShareIcon} from '../share-icon';
import {SharingWidget} from '../sharing-widget';
import '../../i18n/config';

import styles from './article-share-widget.module.css';

const LAYOUT_SECTION = 'main_content_footer';

const ArticleShareWidget = ({articleId}) => {
  const [isOpen, setIsoOpen] = useState(false);
  const containerRef = useRef();
  const buttonRef = useRef();
  const articleData = useArticleModel(articleId);
  const {t} = useTranslation();

  useOnClickOutside(containerRef, () => {
    setIsoOpen(!isOpen);
  }, [buttonRef]);

  const onClick = () => {
    if (navigator.share) {
      const trackingUrl = new URL(articleData.url);

      trackingUrl.searchParams.append('utm_source', 'web-share-api');

      navigator.share({title: articleData.headline, url: trackingUrl.toString()}).catch(console.error);
    } else {
      setIsoOpen(!isOpen);
    }
  };

  const onClose = () => {
    SharingEventLogger.clickArticleShareButton(LAYOUT_SECTION, t('share.article'));
    setIsoOpen(false);
  };

  const onShare = social => {
    SharingEventLogger.shareBySocial(social);
  };

  return (
    <div className={styles.container}>
      <button
        onClick={onClick}
        ref={buttonRef}
        className={clsx(styles.button, {
          [styles.activeButton]: isOpen
        })}
      >
        <ShareIcon className={styles.icon} />
        {t('share.article')}
      </button>
      {isOpen && (
        <div className={styles.widgetWrapper} ref={containerRef}>
          <SharingWidget
            onClose={onClose}
            onCopy={() => onShare(SHARING_COPY)}
            onShare={type => onShare(type)}
            url={articleData.url}
            title={articleData.headline}
            utmMedium={LAYOUT_SECTION}
          />
        </div>
      )}
    </div>
  );
};

ArticleShareWidget.propTypes = {
  articleId: PropTypes.string.isRequired
};

export {ArticleShareWidget};
